import produce from 'immer';
import { TOGGLE_EVENT_TYPE_FILTER_MENU } from './constants';

export const initialState = {
  eventTypeFilterMenuStatus: false,
};

/* eslint-disable default-case, no-param-reassign */
const eventTypeReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case TOGGLE_EVENT_TYPE_FILTER_MENU:
        draft.eventTypeFilterMenuStatus = action.value;
        break;
      default:
        break;
    }
  });

export default eventTypeReducer;
